module.exports = __webpack_public_path__ + "img/access_roles-w.svg";